// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__GLtqy","inner":"Board_inner__3i6KS","board_white":"Board_board_white__KZddV"};